<script lang="ts">
  import { Crisp } from "crisp-sdk-web";
  import { crispChatWebsiteID } from "$lib/config/nucamp.client.json";
	import { user } from "$lib/client/stores/nucamp-user";
  import { geolocation } from "$lib/client/stores/nucamp-geolocation";

  Crisp.configure(crispChatWebsiteID);
  const data:any = {
    website: "www.nucamp.co"
  };

  $: if ($user || $geolocation) {
    if ($user?.email) Crisp.user.setEmail($user.email);
    if ($user?.displayName) Crisp.user.setNickname($user.displayName);
    if ($user?.country) data.country = $user.country;
    if ($geolocation?.country_name) data.country = $geolocation.country_name;
    if ($user?.state) data.country = $user.state;
    Crisp.session.setData(data);
    console.log("Crisp session data set", data);
  }

  // If the URL includes the params "showCrispChat=true", then show the chat widget
  const urlParams = new URLSearchParams(window.location.search);
  const showCrispChat = urlParams.get("showCrispChat");
  if (showCrispChat === "true") {
    Crisp.chat.show();
    Crisp.message.show("text", "Welcome Back! How can I help?");
  }

</script>